import React, { forwardRef, useImperativeHandle } from 'react';

const Header = forwardRef(({ message, type }, ref) => {

    const triggerMessage = () => {

            if(message){
                const messageWrapper = document.getElementsByClassName('message_wrapper')[0];
            
                if (!messageWrapper) {
                    console.error('Message wrapper not found');
                    return;
                }

                document.querySelectorAll('.message_block').forEach(msg => msg.remove());
            
                const messageBlock = document.createElement('div');
                messageBlock.className = 'message_block';
                messageBlock.id = `message_${Date.now()}`;
            
                const iconSpan = document.createElement('span');
                iconSpan.className = type === "success" 
                    ? "fa-solid fa-circle-check message_icon message_icon_green" 
                    : type === "info"
                    ? "fa-solid fa-circle-info message_icon message_icon_blue"
                    : "fa-solid fa-circle-xmark message_icon message_icon_red";
            
                const textNode = document.createElement('span');
                textNode.textContent = message;
            
                const closeButton = document.createElement('div');
                closeButton.className = 'close_message';
                closeButton.innerHTML = '<span class="fa-solid fa-xmark"></span>';
                closeButton.onclick = () => messageBlock.remove();
            
                messageBlock.appendChild(iconSpan);
                messageBlock.appendChild(textNode);
                messageBlock.appendChild(closeButton);
            
                messageWrapper.appendChild(messageBlock);
            
                setTimeout(() => {
                    messageBlock.classList.add("show");
                }, 100);
            
                setTimeout(() => {
                    messageBlock.remove();
                }, 5000);
            }
    };

    useImperativeHandle(ref, () => ({
            triggerMessage
    }));



    return (
      <>
        <div className="header_section">
        
            <div className="message_wrapper">
                
            </div>
            <div className="header_wrapper">
                <div className='header_id_block'>
                    <p className='header_id'><span>ISSN:</span> 2956-0179</p>
                    <p className='header_id'><span>eISSN:</span> 2956-0306</p>
                </div>
                <div className='header_signup_wrapper'>
                    <div className='header_signup_block header_signup'>
                        <a className='header_link' href="https://aseestant.ceon.rs/index.php/AnnNur/user/register" target='_blank' rel="noreferrer">
                            Register <span className="fa-regular fa-circle-user"></span>
                        </a>
                    </div>
                    <div className='header_signup_block header_login'>
                        <a className='header_link' href="https://aseestant.ceon.rs/index.php/AnnNur/login" target='_blank' rel="noreferrer">
                            Login <span className="fa-solid fa-arrow-right-to-bracket"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>  
      </>
    );
});

export default Header;